import agentAddressFormDictionary from '@widgets/agent-address-form/i18n/ru/agent-address-form.dic.json';

export const agentAddressForm = {
  AGENT_ADDRESS_FORM: agentAddressFormDictionary,
};

export const agentAddressFormNamespaces = ['AGENT_ADDRESS_FORM'];
